import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useQuery } from 'react-query';
import { fetchStatements } from '../../api';

export const useFetchTransaction = () => {
  const { accountDetails } = useSelector((state: RootState) => state.user);
  const { nextEndDate } = useSelector((state: RootState) => state.statements);
  const apiName = 'statements';
  const accId = accountDetails.accountId;
  const customerId = accountDetails?.customer?.customerId;
  return useQuery(
    ['fetchStatements'],
    () => fetchStatements(apiName, accId, customerId, nextEndDate),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
    }
  );
};
